/* eslint global-require: 0 */
if (window.Cypress) {
  module.exports = require('./testLink');
} else {
  module.exports = require('./serverLink');
}
